import { onDomReady } from '../../components/dynamic/observer';
import ProjectOffice from './ProjectOffice';

onDomReady(() => {
  new ProjectOffice(document.querySelector('[data-project-office]'));
});
